import {
  Directive,
  HostListener,
  ElementRef,
  Output,
  Input,
  EventEmitter
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appRestrictInput]'
})
export class RestrictInputDirective {
  @Output() invalidCharacter = new EventEmitter<boolean>();

  @Input() restrictSlashes: boolean = true;
  @Input() restrictHyphens: boolean = true;

  private forbiddenPattern = /[\/\\]/g;

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    const isSlash = key === '/' || key === '\\';
    const isHyphen = key === '–' || key === '—';

    if ((this.restrictSlashes && isSlash) || (this.restrictHyphens && isHyphen)) {
      event.preventDefault();
      this.invalidCharacter.emit(true);
    }
  }

  @HostListener('input')
  onInput() {
    this.cleanInput();
  }

  @HostListener('paste')
  onPaste() {
    setTimeout(() => this.cleanInput(), 0);
  }

  private cleanInput() {
    const inputElement = this.el.nativeElement;
    const currentValue = inputElement.value || '';
    let sanitizedValue = currentValue;

    if (this.restrictSlashes) {
      sanitizedValue = sanitizedValue.replace(/[\/\\]/g, '');
    }

    if (this.restrictHyphens) {
      sanitizedValue = sanitizedValue.replace(/[\u2013\u2014]/g, '-');
    }

    const wasInvalid = currentValue !== sanitizedValue;

    if (wasInvalid) {
      // Update the DOM manually
      inputElement.value = sanitizedValue;

      // Update the FormControl manually (IMPORTANT in Angular 5)
      if (this.control && this.control.control) {
        this.control.control.setValue(sanitizedValue);
      }

      this.invalidCharacter.emit(true);
    } else {
      this.invalidCharacter.emit(false);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/restrict-input.directive.ts